const ComponentSpinner = () => {
  return (
    <div className='fallback-spinner' style={{ zIndex: 2001 }}>
      <div className='loading component-loader'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default ComponentSpinner
